import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import Button from '../common/components/Button';
import NoContent from '../common/components/NoContent';
import NoUserIcon from '../../assests/img/no-user.svg?react';
import {getDataApi, getUserTotalApi} from '../common/api/getApiData';
import {userType} from '../common/context/filterContext';
import  '../../assests/css/manageuser.scss';
import ContentHeader from '../common/components/ContentHeader';
import AddUser, {newUserType} from './AddUser';
import FilterIcon from '../../assests/img/filter.svg?react';
import SettingsIcon from '../../assests/img/settings-icon.svg?react';
import Checkbox from '../common/components/Checkbox';
import Pagination from '../common/components/Pagination';
import {listItemPerPage} from '../../constants/options';
import ManageMenu, {menuItemIdType} from './ManageMenu';
import ManageUser from './ManageUser';
import ChangeRole from './ChangeRolePopup';
import DeactivateUserPopup from './DeactivateUserPopup';
import ResetPasswordPopup from './ResetPasswordPopup';
import {convertDate, getDateInYYYYMMDD, getUserPermisson} from '../common/functions/utils';
import SortBy, {sortByType} from '../common/components/SortBy';
import {addNewUserApi} from '../common/api/postApi';
import {toast} from 'react-toastify';
import Loader from '../common/components/Loader';
import {updateUserApi} from '../common/api/updateApi';
import {msalInstance} from '../..';
import {AuthCodeMSALBrowserAuthenticationProvider} from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import _ from 'lodash';
import {InteractionType} from '@azure/msal-browser';
import {Client} from '@microsoft/microsoft-graph-client';
import TextInput from '../common/components/TextInput';
import AddIcon from '../../assests/img/add-icon.svg?url';
import Select from 'react-select';
import CustomDropdownIndicator, {CustomDropdownClearIndicator} from '../common/components/CustomDropdownIndicator';
import {DEFINED_ROLES} from '../../constants/permission';
import {AuthContext} from '../common/context/authContext';
import DatePicker from 'react-datepicker';
import {UserContext} from '../common/context/userContext';
import CloseIcon from '../../assests/img/close-icon-grey.svg?react';


const userStatusDropdown = [
    {value: 'All', label: 'All'},
    {value: 'Active', label: 'Active'},
    {value: 'Inactive', label: 'Inactive'},
];

export interface userDataType extends userType {
    createdOn: string,
    updatedOn: string,
    lastLogin: string,
    userStatus: boolean,
    userRoleId: string,
    userRoleName: string,
    azureUserId: string,
}

interface userFilterType extends Omit<userDataType, 'userRoleId' | 'updatedOn' | 'id' | 'lastName'> {
}
type columnSortId = 'firstName' | 'email' | 'userStatus' | 'lastLogin' | 'createdOn' | 'userRoleName';

function UserContent() {
    const {data: {permissions}} = useContext(UserContext);
    const {accounts} = useContext(AuthContext);
    const [
        users,
        setUsers,
    ] = useState<userDataType[]>([
    ]);
    const [
        totalUsers,
        setTotalUsers,
    ] = useState<number>(0);
    const [
        showPopup,
        setShowPopup,
    ] = useState<boolean>(false);
    const [
        showMenuContent,
        setShowMenuContent,
    ] = useState<boolean>(false);
    const [
        menuId,
        setMenuId,
    ] = useState<menuItemIdType>('None');
    const [
        showMenuItemPopup,
        setShowMenuItemPopup,
    ] = useState<boolean>(false);
    const [
        currentPage,
        setCurrentPage,
    ] = useState(1);
    const [
        sortByValue,
        setSortByValue,
    ] = useState<{[key: string]: sortByType}>({
        firstName: 'default',
        email: 'default',
        role: 'default',
        createdOn: 'default',
        lastLogin:  'default',
        status: 'default',
    });
    const [
        loading,
        setLoading,
    ] = useState(false);
    const [
        selectedUser,
        setSelectedUser,
    ] = useState<userDataType>({
        id: 0,
        firstName: '',
        lastName: '',
        lastLogin: '',
        createdOn: '',
        userStatus: false,
        userRoleId: '',
        userRoleName: '',
        email: '',
        updatedOn: '',
        azureUserId: '',
    });
    const [
        userRoles,
        setUserRoles,
    ] = useState<{
        userRoleId: string, userRoleName: string, permission: string}[]>([
    ]);
    const [
        showFilter,
        setShowFilter,
    ] = useState<boolean>(false);
    const [
        filterContent,
        setFilterContent,
    ] = useState<{[key in keyof userFilterType]: string}>({
        firstName: '',
        lastLogin: '',
        createdOn: '',
        userRoleName: '',
        email: '',
        userStatus: '',
        azureUserId: '',
    });

    const getUserData = useCallback(async (
        orderByStr?: string, search?: string, filterBy?: string,
    ) => {
        setLoading(true);
        const filter = orderByStr && search && filterBy ? `?${orderByStr}&SearchQuery=${search}&${filterBy}` : orderByStr ? `?${orderByStr}` : search ? `?SearchQuery=${search}`: filterBy ? `?${filterBy}` : '';
        const value = await getDataApi(`GetUser${filter}`, accounts);
        setUsers(value);
        setLoading(false);
    }, [
    ]);

    const getUserSearch = useMemo(() => _.debounce(getUserData, 700), [
    ]);

    const getUserFilter = useMemo(() => _.debounce(getUserData, 700), [
    ]);

    const getUserRoles = useCallback(async () => {
        const roles = await getDataApi('GetUserRole', accounts);
        setUserRoles(roles.map((role: any) => {
            return {
                userRoleId: role.userRoleId,
                userRoleName: role.userRoleName,
                permission: role.permission,
            };
        }));
        setLoading(false);
    }, [
    ]);

    const getUserTotal = useCallback(async () => {
        const {value} = await getUserTotalApi(accounts);
        if (value && value.length) {
            setTotalUsers(value[0].totalUsers);
        }
    }, [
    ]);

    useEffect(() => {
        getUserTotal();
    }, [
        getUserTotal,
    ]);

    useEffect(() => {
        getUserRoles();
    }, [
        getUserRoles,
    ]);

    useEffect(() => {
        const orderBy = Object.keys(sortByValue).filter((key) => {
            return sortByValue[key] !== 'default'; 
        }).map((key1) => {
            return `${key1}:${sortByValue[key1] === 'asc' ? 1 : 2}`;
        });
        let orderByStr = `${orderBy.join(',')}`;
        orderByStr = orderByStr ? `CommaSepColumn=${orderByStr}`: '';
        getUserData(orderByStr);
    }, [
        sortByValue, getUserData,
    ]);

    const handleSearch = (search: string) => {
        getUserSearch('',search);
    };

    const getGraphClient = () => {
        const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
            msalInstance, {
            account: accounts[0],
            interactionType: InteractionType.Popup,
            scopes: ['User.Read'],
        });
        const options = {
            authProvider: authProvider,
        }
        const graphClient = Client.initWithMiddleware(options);

        return graphClient;
    };

    const getUserGroupId = (userRoleId: string) => {
        const userRole = userRoles.filter((role) => {
            return role.userRoleId.toString() === userRoleId.toString();
        })[0];

        if (!userRole) {
            toast.error('User group cannot be found');
            return '';
        }

        const userGroupId = DEFINED_ROLES[userRole.permission].groupId;

        return userGroupId;
    };

    const addUserToAzureUserGroup = async (
        userId: string,
        userData: newUserType, userGroupId: string, graphClient: Client) => {
        // Assign to security group
        const userObject = {
            '@odata.id': `https://graph.microsoft.com/v1.0/users/${userId}`,
            '@odata.userPrincipalName': `${userData.email}`,
            '@odata.displayName': `${userData.firstName} ${userData.lastName}`,
            '@odata.givenName': `${userData.firstName}`,
            '@odata.surname': `${userData.lastName}`
        };
        await graphClient.api(`/groups/${userGroupId}/members/$ref`).post(userObject);
    };

    const removeUserToAzureUserGroup = async (
        userId: string, userGroupId: string, graphClient: Client) => {
        // Remove to security group
        await graphClient.api(`/groups/${userGroupId}/members/${userId}/$ref`).delete();
    };

    const addNewUser = async (newUser: newUserType) => {  
        try {
            const graphClient = getGraphClient();
            const userGroupId = getUserGroupId(newUser.userRoleId);
            let userId = '';
            
            if (newUser.email && newUser.email.split('@')[1] !== 'gozeal.com') {
                // Invite guest user
                const invitation = {
                    invitedUserEmailAddress: newUser.email,
                    invitedUserDisplayName: `${newUser.firstName} ${newUser.lastName}`,
                    inviteRedirectUrl: import.meta.env.VITE_REDIRECT_URI,
                    sendInvitationMessage: true,
                };
                const invitee = await graphClient.api('/invitations').post(invitation);
                userId = invitee.invitedUser.id;
                toast.success('User invite sent successfully');

                await addUserToAzureUserGroup(
                    invitee.invitedUser.id, newUser, userGroupId, graphClient);
            } else {
                // Get user
                const user = await graphClient.api(`/users('${newUser.email}')`).get();
                userId = user.id;
                // Assign to security group
                await addUserToAzureUserGroup(
                    user.id, newUser, userGroupId, graphClient);
            }

            try {
                const response = await addNewUserApi(
                    {...newUser, azureUserId: userId}, accounts);
                if (response.status === 201) {
                    toast.success('User added successfully');
                    setShowPopup(false);
                    getUserData();
                }
                return true
            } catch (e: any) {
                toast.error(e.message);
                return false;
            }

        } catch (e: any) {
           toast.error(JSON.parse(e.body).message);
           return false;
        }
    };

    const moveUserToNewUserGroup = async (newRoleId: string) => {
        const graphClient = getGraphClient();
        const newUserGroupId = getUserGroupId(newRoleId);
        const currentUserGroupId = getUserGroupId(selectedUser.userRoleId);
        const user = await graphClient.api(`/users('${selectedUser.azureUserId}')`).get();
        await addUserToAzureUserGroup(
            user.id, selectedUser, newUserGroupId, graphClient);
        await removeUserToAzureUserGroup(
            user.id, currentUserGroupId, graphClient);
    };

    const updateUser = async (
        userId: string, field: keyof userDataType | 'All', value: any,
    ) => {
        try {
            const valueToUpdated = field !== 'All' ? {[field] : value} : {firstName: value.firstName, lastName: value.lastName, email: value.email, userRoleId: value.userRoleId};

            const res = await updateUserApi(`User/id/${userId}`, valueToUpdated, accounts);

            if (res === 200) {
                if (field === 'userStatus') {
                    toast.success(`User ${value ? 'activated' : 'de-activated'} successfully`);
                }
    
                if (field === 'userRoleId') {
                    await moveUserToNewUserGroup(value);
                    toast.success('User role updated successfully');
                }
                if (field === 'All') {
                    if (value.userRoleId !== selectedUser.userRoleId) {
                        await moveUserToNewUserGroup(value.userRoleId);
                    }
                    toast.success('User updated successfully');
                }
                setShowMenuItemPopup(false);
                setSelectedUser((prevState) => {
                    return {
                        ...prevState,
                        ...valueToUpdated,
                    };
                });
                getUserData();
                return true;
            } else {
                setShowMenuItemPopup(false);
                toast.error(res.data.error.message);
                return false;
            }
        } catch (error: any) {
            setShowMenuItemPopup(false);
            toast.error(JSON.parse(error.body).message);
            return false;
        }
    };

    const handleMenuItemClick = (menuId: menuItemIdType) => {
        setShowMenuContent(true);
        setMenuId(menuId);
        if (menuId !== 'None' && menuId !== 'manageUser') {
            setShowMenuItemPopup(true);
        }
    };

    const handleMenuClick = (userId: number) => {
        const matchedUser = users.filter((user) => user.id === userId)[0];
        setSelectedUser(matchedUser);
    };

    const handleSort = (sortType: sortByType, columnId: columnSortId) => {
        setSortByValue((prevState) => {
            return {
                ...prevState,
                [columnId]: sortType,
            };
        });
    };

    const handleClearSort = (columnSortId: columnSortId) => {
        setSortByValue((prevState) => {
            return {
                ...prevState,
                [columnSortId]: 'default',
            };
        });
    };

    const handleShowFilter = () => {
        setShowFilter(!showFilter);
    };

    const handleFilter = (field: keyof userDataType, value: any) => {
        const filterContentCopy = {
            ...filterContent,
            [field]: (
                field === 'userStatus' ?
                value ? value.value : '':
                field === 'createdOn' || field === 'lastLogin' ?
                value ? getDateInYYYYMMDD(value) : ''
            : field === 'userRoleName' ? value ? value.label : '' : value),
        };

        setFilterContent(filterContentCopy);
        const filterBy = Object.keys(filterContentCopy).filter((key) => {
            return filterContentCopy[key as keyof userFilterType] !== ''; 
        }).map((key1) => {
            switch (key1 as keyof userFilterType) {
                case 'firstName':
                default:
                    return `FirstNameFilter=${filterContentCopy[key1 as keyof userFilterType]}`;
                case 'email':
                    return `EmailFilter=${filterContentCopy[key1 as keyof userFilterType]}`;
                case 'createdOn':
                    return `CreatedOnFilter=${filterContentCopy[key1 as keyof userFilterType]}`;
                case 'lastLogin':
                    return `LastActiveFilter=${filterContentCopy[key1 as keyof userFilterType]}`;
                case 'userRoleName':
                    return `RoleNameFilter=${filterContentCopy[key1 as keyof userFilterType]}`;
                case 'userStatus':
                    return `UserStatusFilter=${filterContentCopy[key1 as keyof userFilterType]}`;
            }
        });
        const filterbyStr = `${filterBy.join('&')}`;
        getUserFilter('','', filterbyStr);
    };

    const getTotalPages = () =>
        users.length<=listItemPerPage ? 1 :
    Math.ceil(users.length / listItemPerPage);

    const getStartEndIndices = () => {
        const start = currentPage === 1? 0:
        (currentPage-1) * listItemPerPage;
        const end = currentPage === 1?
        listItemPerPage: start + (listItemPerPage);
        return [start, end];
    }

    const paginatedUserData = (users: userDataType[]) => {
        if (users.length<=6) {
            return users;
        } else {
            const [start, end] = getStartEndIndices();
            const cardDataPaginated = users.slice(start, end);
            return cardDataPaginated;
        }
    }

    const isAdminUser = (roleId: string) => {
        const index = userRoles.findIndex((role) => role.userRoleId === roleId && role.permission.includes('A'));
        return index > -1;
    };

    const renderManageMenuContent = () => {
        return (
            <ManageUser
                onClickBack={() => setShowMenuContent(false)}
                onDeactivateUser={(userId, userStatus) =>
                    updateUser(
                        userId, 'userStatus', userStatus ? false : true)}
                onSubmit={(user) => updateUser(user.id.toString(), 'All', user)}
                userData={selectedUser}
                userRoles={[...userRoles]}
            />
        );
    }

    const renderOtherPopup = () => {
        switch(menuId) {
            case 'changeRole':
                return (<ChangeRole
                    showPopup={showMenuItemPopup}
                    userRoles={[...userRoles]}
                    userRoleId={selectedUser.userRoleId}
                    onClose={(show) => setShowMenuItemPopup(show)}
                    showDropdown={true}
                    onChangeRole={(role) =>
                        updateUser(selectedUser.id.toString(), 'userRoleId', role)}
                    />);
            case 'deactivateUser':
                return (<DeactivateUserPopup
                    showPopup={showMenuItemPopup}
                    onClose={(show) => setShowMenuItemPopup(show)}
                    deactivateUser={(userId) =>
                        updateUser(userId, 'userStatus', false)} 
                    userId={selectedUser.id.toString()}
                    userStatus={selectedUser.userStatus}
                    email={selectedUser.email}/>);
            case 'activate':
                return (<DeactivateUserPopup
                    showPopup={showMenuItemPopup}
                    onClose={(show) => setShowMenuItemPopup(show)}
                    deactivateUser={(userId) =>
                        updateUser(userId, 'userStatus', true)} 
                    userId={selectedUser.id.toString()}
                    userStatus={selectedUser.userStatus}
                    email={selectedUser.email}/>);
            case 'resetPassword':
                return (<ResetPasswordPopup
                    showPopup={showMenuItemPopup}
                    onClose={(show) => setShowMenuItemPopup(show)}/>);
        }
    };

    const filterDropdownValue = (field: keyof userFilterType) => {
        switch (field) {
            case 'userRoleName':
                return (userRoles.map((role) => {
                    return {
                        value: role.userRoleId,
                        label: role.userRoleName,
                    }
                }))
            case 'userStatus':
            default:
                return [
                    ...userStatusDropdown,
                ];
        }
    };

    const getSelectedFilterDropdownValue = (
        field: keyof userFilterType, value: string,
    ) => {
        switch (field) {
            case 'userRoleName':
                return userRoles.filter((role) => {
                    return role.userRoleId === value;
                }).map((item) => {
                    return {
                        value: item.userRoleId, label: item.userRoleName
                    }})[0];
            case 'userStatus':
            default:
                return userStatusDropdown.filter((userStatus) => {
                    return userStatus.value === value;
                })[0];
        }
    };

    const renderFilter = (
        type: 'text' | 'select' | 'date', field: keyof userFilterType,
    ) => {
        switch (type) {
            case 'text':
                return (
                    <div className='position-relative'>
                        <TextInput text={filterContent[field]}
                        onChange={(text) => handleFilter(field, text)}
                        type='text' placeholder=''
                        className='manage-user-filter-component'/>
                        {filterContent[field] ?
                        <div
                            className='position-absolute'
                            style={{right: 0,
                                top: '40%',
                                paddingRight: '6px',
                                cursor: 'pointer',
                            }}
                            onClick={() => handleFilter(field, '')}
                        >
                            <CloseIcon width={8} height={8}/>
                        </div> : null}
                    </div>
                );
            case 'date':
                return (
                    <DatePicker
                        selected={filterContent[field] ?
                            new Date(filterContent[field]) : null}
                        isClearable
                        clearButtonClassName='manage-user-filter-clear'
                        className='text-input manage-user-filter-component'
                        onChange={(date) => handleFilter(field, date)}
                    />
                );
            case 'select':
                return (
                    <Select
                        options={filterDropdownValue(field)}
                        defaultValue={{
                            value: filterContent[field],
                            label: filterContent[field]}}
                        value={
                            getSelectedFilterDropdownValue(
                                field, filterContent[field])
                        }
                        placeholder=''
                        isSearchable
                        isClearable={filterContent[field] ? true : false}
                        onChange={(value) => handleFilter(field, value)}
                        components={{
                            DropdownIndicator: CustomDropdownIndicator,
                            ClearIndicator: CustomDropdownClearIndicator,
                        }}
                        styles={{
                            indicatorSeparator: (base) => ({
                                ...base,
                                display: 'none',
                            }),
                            control: (base) => ({
                                ...base,
                                minHeight: '22px',
                                height: '22px',
                                flexWrap: 'initial',
                            }),
                            input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                margin: 0,
                                padding: '0px 8px',
                            }),
                            singleValue: (base) => ({
                                ...base,
                                margin: 0,
                            }),
                        }}
                        className='input-select manage-user-filter-component'
                    ></Select>
                )
            default:
                return (<TextInput text={filterContent[field]}
                    onChange={(text) => handleFilter(field, text)}
                    type='text' placeholder=''
                    className='manage-user-filter-component'/>);
        }
    };

    const paginedData = paginatedUserData(users);

    const renderContent = () => {
        return (
            <>
                <ContentHeader
                    title='All Users'
                    count={users.length} customClass='manage-user-list-content-header'
                    showDownload={false}
                    onSearch={handleSearch}
                    ctaProps={{
                        buttonText: 'Add',
                        onClick: () => setShowPopup(true),
                        type: 'primary-outline',
                        buttonIconUrl: AddIcon,
                    }}
                    showSort={false}
                    showAdd={getUserPermisson(permissions, 'A')}
                    showWholesalers={false}
                    onWholesalersSelect={()=> null}/>
                <AddUser
                    showPopup={showPopup}
                    userRoles={[...userRoles]}
                    setShowPopup={setShowPopup}
                    addUser={(newUser) => addNewUser(newUser)}
                />
                {showMenuContent && renderOtherPopup()}
                {!loading ? totalUsers ?
                <div className='content-container-box-shadow'>
                    <div className='content-container-scrollable markex-scroll'>
                        <table className='manage-user-list'>
                            <tbody>
                            <tr>
                                <td className='manage-user-list-header'>
                                    <span className='d-flex align-items-center gap-2'>
                                    {/* <Checkbox onClick={(checked) => checked} 
                                    selected={false}/> */}
                                    <SortBy sortType={sortByValue.firstName} onClick={(sortby) => handleSort(sortby, 'firstName')} onClear={() => handleClearSort('firstName')}/> Name</span>
                                    {showFilter ? renderFilter('text', 'firstName') : null}
                                </td>
                                <td className='manage-user-list-header'>
                                    <span className='d-flex align-items-center gap-2'>
                                        <SortBy sortType={sortByValue.email} onClick={(sortby) => handleSort(sortby, 'email')} onClear={() => handleClearSort('email')}/> Email</span>
                                        {showFilter ? renderFilter('text', 'email') : null}
                                </td>
                                <td className='manage-user-list-header'>
                                    <span className='d-flex align-items-center gap-2'>
                                        <SortBy sortType={sortByValue.userRoleName} onClick={(sortby) => handleSort(sortby, 'userRoleName')} onClear={() => handleClearSort('userRoleName')}/> Role</span>
                                        {showFilter ? renderFilter('select', 'userRoleName') : null}
                                </td>
                                <td className='manage-user-list-header'>
                                    <span className='d-flex align-items-center gap-2'>
                                        <SortBy sortType={sortByValue.createdOn} onClick={(sortby) => handleSort(sortby, 'createdOn')} onClear={() => handleClearSort('createdOn')}/> Date Onboarded</span>
                                        {showFilter ? renderFilter('date', 'createdOn') : null}
                                </td>
                                {/* <td className='manage-user-list-header'>
                                    <span className='d-flex align-items-center gap-2'>
                                        <SortBy sortType={sortByValue.lastLogin} onClick={(sortby) => handleSort(sortby, 'lastLogin')} onClear={() => handleClearSort('lastLogin')}/> Last Active</span>
                                        {showFilter ? renderFilter('date', 'lastLogin') : null}
                                </td> */}
                                <td className='manage-user-list-header'>
                                    <span className='d-flex align-items-center justify-content-between'>
                                        <span className='d-flex align-items-center gap-2'>
                                        <SortBy sortType={sortByValue.userStatus} onClick={(sortby) => handleSort(sortby, 'userStatus')} onClear={() => handleClearSort('userStatus')}/> Status
                                        </span>
                                        <span className='px-2'
                                            onClick={handleShowFilter} style={{cursor: 'pointer'}}>
                                            <FilterIcon width={'12'} height={'12'}/></span> 
                                    </span>
                                    {showFilter ? renderFilter('select', 'userStatus') : null}
                                </td>
                            </tr>
                            {!loading ? paginedData.length ?
                            paginedData.map((user) => {
                                return (
                                    <tr key={`user-id-${user.id}`}>
                                        <td className='manage-user-list-cell'>
                                            <span className='d-flex align-items-center gap-1'>
                                                <Checkbox
                                                    onClick={(checked) =>
                                                        checked}
                                                    selected={
                                                        selectedUser.id ===
                                                        user.id}/>
                                                <span>
                                                    {user.firstName}&nbsp;
                                                    {user.lastName}
                                                </span>
                                            </span>
                                        </td>
                                        <td className='manage-user-list-cell'>{user.email}</td>
                                        <td className='manage-user-list-cell'>
                                            {user.userRoleName}
                                        </td>
                                        <td className='manage-user-list-cell'>{convertDate(user.createdOn)}</td>
                                        {/* <td className='manage-user-list-cell'>{user.lastLogin ? convertDate(user.lastLogin) : user.lastLogin}</td> */}
                                        <td className='manage-user-list-cell'>
                                            <span className='d-flex align-items-center justify-content-between'>
                                                <span>{user.userStatus ? 'Active' : 'Inactive'}</span>
                                                <ManageMenu
                                                targetElement={<SettingsIcon/>} 
                                                targetId={user.id}
                                                userStatus={user.userStatus}
                                                isAdmin={
                                                    isAdminUser(
                                                        user.userRoleId)}
                                                onClickMenuItem={
                                                    handleMenuItemClick}
                                                onClick={(show, id) =>
                                                handleMenuClick(id)}
                                                />
                                            </span>
                                        </td>
                                    </tr>
                                )
                        }) : <tr>
                                <td colSpan={6}>
                                    <NoContent
                                        textToDisplay='No results for the search / filter(s)'
                                        cta={<></>}
                                        mainImage={<></>}
                                        customClassName='h-auto pt-4'
                                    />
                                </td>
                            </tr>
                            :
                            <tr>
                                <td colSpan={6}>
                                    <Loader/>
                                </td>
                            </tr>
                            }
                        </tbody></table>
                    </div>
                    <Pagination
                        totalPages={getTotalPages()}
                        currentPage={currentPage}
                        pageStatusText={`Showing ${listItemPerPage} items per page of ${users.length} items`}
                        setCurrentPage={(page) => setCurrentPage(page)} customClassName='content-container-pagination'
                    />
                </div> :
                <NoContent
                    textToDisplay={'Start inviting users to manage them'}
                    cta={
                        <Button
                            buttonText='Add User'
                            type='primary'
                            onClick={() => setShowPopup(true)}
                        />
                    }
                    mainImage={<NoUserIcon width={'337'} height={'272'}/>}
                /> : <Loader/>}
            </>
        );
    };

    return  showMenuContent && menuId === 'manageUser' ? renderManageMenuContent() : renderContent();

}

export default UserContent;
